import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './FileManager.css';

const Folder = ({ folder, onClick }) => {
  return (
    <div className="file-item" onClick={() => onClick(folder.id,folder.name)}>
      <div className={`file-item-icon far fa-folder text-secondary`}></div>
      <div className="file-item-name">
        {folder.name}
      </div>
    </div>
  );
};

export default Folder;
